import logo from './logo.svg';
import "./components/css/player.css"
import Player from './components/Player';

function App() {
  return (
    <div className="App">
      <Player className="player"/>
      <h1>Mission JE</h1>
    </div>
  );
}

export default App;
